import styled from 'styled-components';

import { grey4 } from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';

type ToolBarItemShapesProps = {
  $colour: string;
};
export const ToolBarItemShapesFill = styled.div<ToolBarItemShapesProps>`
  background-color: ${({ $colour }) => $colour};
  border: 2px solid ${grey4};
  border-radius: ${rem(2)};
  width: ${rem(20)};
  height: ${rem(20)};
`;

export const ToolBarItemShapesStroke = styled.div<ToolBarItemShapesProps>`
  background-color: ${grey4};
  border: 2px solid ${({ $colour }) => $colour};
  border-radius: ${rem(2)};
  width: ${rem(20)};
  height: ${rem(20)};
`;
